var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRowVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5834 18.9583H3.41675C1.81675 18.9583 1.04175 18.1417 1.04175 16.475V13.1083C1.04175 11.4333 1.81675 10.625 3.41675 10.625H16.5834C18.1834 10.625 18.9584 11.4417 18.9584 13.1083V16.475C18.9584 18.1417 18.1834 18.9583 16.5834 18.9583ZM3.41675 11.875C2.57508 11.875 2.29175 12.05 2.29175 13.1083V16.475C2.29175 17.5333 2.57508 17.7083 3.41675 17.7083H16.5834C17.4251 17.7083 17.7084 17.5333 17.7084 16.475V13.1083C17.7084 12.05 17.4251 11.875 16.5834 11.875H3.41675Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5834 9.37533H3.41675C1.81675 9.37533 1.04175 8.55866 1.04175 6.89199V3.52533C1.04175 1.85033 1.81675 1.04199 3.41675 1.04199H16.5834C18.1834 1.04199 18.9584 1.85866 18.9584 3.52533V6.89199C18.9584 8.55866 18.1834 9.37533 16.5834 9.37533ZM3.41675 2.29199C2.57508 2.29199 2.29175 2.46699 2.29175 3.52533V6.89199C2.29175 7.95033 2.57508 8.12533 3.41675 8.12533H16.5834C17.4251 8.12533 17.7084 7.95033 17.7084 6.89199V3.52533C17.7084 2.46699 17.4251 2.29199 16.5834 2.29199H3.41675Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRowVertical);
export default __webpack_public_path__ + "static/media/row-vertical.9e58b700cd4ede1c39b36a89bf37b702.svg";
export { ForwardRef as ReactComponent };